import { render } from "./InfoEdit.vue?vue&type=template&id=5c2f2181&scoped=true"
import script from "./InfoEdit.vue?vue&type=script&lang=js"
export * from "./InfoEdit.vue?vue&type=script&lang=js"

import "./InfoEdit.vue?vue&type=style&index=0&id=5c2f2181&lang=css"
import "./InfoEdit.vue?vue&type=style&index=1&id=5c2f2181&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2f2181"]])

export default __exports__